/**
 * @fileoverview 403 Forbidden page.
 * @description Shown when a signed-in user is denied access to a resource. Composes the auth page
 * shell with the shared error-state card.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useTranslation } from 'react-i18next'

import forbiddenIcon from '@/assets/svg/errors/icon-forbidden.svg'
import AuthLayout from '@/shared/components/layouts/AuthLayout'
import ErrorStateCard from '@/shared/components/molecules/ErrorStateCard'

/**
 * @component
 */
function ForbiddenPage() {
  const { t } = useTranslation()

  return (
    <AuthLayout>
      <ErrorStateCard
        statusCode="403"
        icon={forbiddenIcon}
        accent="error"
        title={t('errors.forbidden.title')}
        description={t('errors.forbidden.description')}
      />
    </AuthLayout>
  )
}

export default ForbiddenPage
